// extracted by mini-css-extract-plugin
export default {"parent":"authTermsAndConditions_parent__ZKS-H","parentTermsAndConditions":"authTermsAndConditions_parentTermsAndConditions__AGq9b"};